import { Component,Input,OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { scheduleService } from '../../service/schedule.service';
import { facultyService } from '../../service/faculty.service';
import { sessionService } from '../../service/session.service';
import {commonService} from "../../service/common.service";
import {contentService} from "../../service/content.service";
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Http, ResponseContentType } from '@angular/http';

import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';

@Component({
  selector: 'app-addfreedownload',
  templateUrl: './addfreedownload.component.html',
  styleUrls: ['./addfreedownload.component.css'],
  providers:[scheduleService,facultyService,sessionService,commonService,contentService]
})
export class AddfreedownloadComponent implements OnInit {
//activeTab = "basic";
subjectbox:any;
pageInfo:any;
public addscheduleForm: FormGroup;
formvailidation=false;
msg:any;
isSuccess=false;
isError=false;
teacherbox:any;
centerbox:any;
emailvailidation=false;
scheduleId:any;
schedule:any;
coursebox:any;
batchtypebox:any;
Exambox:any;
streambox:any;
venuebox:any;
branchbox:any;
topicbox:any;
doc:any;
disabled=true;
docId:number;

tagcenter:any;
tagstream:any;
tagcourse:any;
tagbatchtype:any;
tagexam:any;
tagsubject:any;
tagusertype:any;
tagposttopic:any;
attachmnet:any;




userType=[{'display':'Guest','value':1},{'display':'Paid Guest','value':2},{'display':'Student','value':3},{'display':'Alumni','value':4},{'display':'Faculty','value':5}];
constructor(private http:Http,private _content:contentService,public router: Router,private commonService:commonService,private _schedule:scheduleService,private _session:sessionService,private _faculty:facultyService,private frmBuilder: FormBuilder,private route: ActivatedRoute,private global:Globals) { 
  



  this.doc = {
    title: '',
    status:'',
    uploadedoc:[],
    component:''
  }

  this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
  this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  this.uploader.clearQueue = ()=>this.clearQueue();


}

readonly rootUrl = this.global.siteUrl;
url =this.rootUrl+'file/upload?folder='+this.global.postAttachmentFolder;
path=this.global.docAttachmentUrl;
@Input() fileExt: string = "";
errors: Array<string> =[];
fileExtExists=false;
uploader:FileUploader=new FileUploader({url:this.url,authToken:sessionStorage.getItem('_to'),maxFileSize: 2*1024*1024*1024,allowedMimeType: ['image/png','image/jpeg','image/jpg','application/pdf','video/mp4','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/msword']});
attactmentlist:any=[];


ngOnInit() {


  //console.log(test);
  this.route.params.subscribe(params => { 
    if(params['id']){
         this.docId = params['id'];
          this.getdoc(parseInt(params['id']));
    }
  });



  this.getposttopic();

}

// get doc if id is exist in db
getdoc(docId){
      this._content.getdownloadContentbydocId({'id':docId}).subscribe((data : any)=>{    
        if(data.error==0){
          var attachmnetdoc  = []; 
          attachmnetdoc.push(data.results.docAttachments);
           this.doc = {
            title: data.results.title,
            status: data.results.status,
            uploadedoc :data.results.docAttachments,
            comment:data.results.comment
           }
           this.tagposttopic  =  data.results.topic;
       
          }
      });
}


getposttopic(){
  var category='Material';
  this._content.getposttopic(category).subscribe((data : any)=>{     
    if(data.error==0){     
     var objArray = {};
     var mainArray = [];
     for(var row of data.results){
        objArray['display']= row.title;
        objArray['value']= row.id;
          mainArray.push(objArray);
          objArray = {};
      }
     this.topicbox = mainArray;
     this.doc.topic=this.getpermissionArray(this.tagposttopic,this.topicbox);
    
  }else{
      if(data.message=="Failed to authenticate token."){
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['/admin']);
      }else{
       this.msg = data.message;
       this.isError = true;
      }
    }
  },
  (error : HttpErrorResponse)=>{
  this.isError = true;
  this.msg="internal server error!";
  });  
  

}



adddoc(adddocForm) {
if(adddocForm.status=="INVALID"){
 this.formvailidation=true;
}else{
 this.formvailidation=false;
      adddocForm.value['docId']   = this.docId;
      this._content.adddocDownload(adddocForm.value).subscribe((data : any)=>{
        if(data.error==0){ 
          this.router.navigateByUrl('/admin/discussion/freedownload');
        }else{
          if(data.message=="Failed to authenticate token."){
            this.router.navigate(['/admin']);
          }else{
          this.msg = data.message;
          this.isError = true;
          }
        }
    },
        (error : HttpErrorResponse)=>{
          this.isError = true;
          this.msg="internal server error!";
        });

}
}


getpermissionArray(selectedtag,tagarray){ 
   var selectedArray = [];
   if(tagarray instanceof Array){
    for(var tag of  tagarray){
      var personRegExp = new RegExp(tag.value);
      if(personRegExp.test(selectedtag)) {
           selectedArray.push(tag);
      }
    }
  }
    return selectedArray;
}

permisssionArraytoString(tagarray){

var selectedArray = [];
var selectedString="";
   if(tagarray instanceof Array){
    for(var tag of  tagarray){
      selectedArray.push(tag.value);
    }
    selectedArray.toString();
  }
    return  selectedArray.toString();
}

/****file uploder responce***/
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  let data = JSON.parse(response); //success server response

    if(data.error==0){
      this.attactmentlist.push(data.result.id);
    }
 
   
}

onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
}  

ngAfterViewInit() {
  this.uploader.onAfterAddingFile = (item => {
     item.withCredentials = false;
  });
 }

 clearQueue() {
  this.uploader.queue = [];
  this.attactmentlist=[];
  
  
 }
/****file uploder responce***/

removeFile(item) {
  this.uploader.removeFromQueue(item);
}

deldoc(docId){

var MainArray = [];
var ObjArry= {};

  this._content.delAttachemet(docId).subscribe((data : any)=>{     
    if(data.error==0){  
      
      for(var attach of this.attachmnet){
        if(attach.id!=docId){
         MainArray.push(attach);
        }
       }
   
       this.attachmnet =MainArray;

     
  }else{
      if(data.message=="Failed to authenticate token."){
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['/admin']);
      }else{
       this.msg = data.message;
       this.isError = true;
      }
    }
  },
  (error : HttpErrorResponse)=>{
  this.isError = true;
  this.msg="internal server error!";
  });





}

public downloadFile(filename) {

  return this.http.get(this.path+filename,{
    responseType: ResponseContentType.Blob,
  })
  .map(res => {
    return {
      filename: filename,
      data: res.blob()
    };
  }).subscribe(res => {
      var url = window.URL.createObjectURL(res.data);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = res.filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }, error => {
      //console.log('download error:', JSON.stringify(error));
           if(error.status="404"){
                  alert('Something went wrong. Please try to latter.');
           }
    }, () => {
     // console.log('Completed file download.')
    });
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/addfreedownload/addfreedownload.component.ts